import { useQuery } from '@tanstack/react-query'
import { transactionsAPI, adminAPI } from '../services/api'

export const useTransactionDetails = (transactionId, options = {}) => {
  return useQuery({
    queryKey: ['admin', 'transaction-details', transactionId],
    queryFn: async () => {
      if (!transactionId) {
        throw new Error('Transaction ID is required')
      }
      
      const response = await transactionsAPI.getTransactionDetails(transactionId)
      return response.data.data
    },
    enabled: !!transactionId && options.enabled !== false,
    staleTime: 30000, // 30 seconds
    refetchOnWindowFocus: false,
    ...options,
  })
}

export const useTransactionNotes = (transactionId, { page = 1, limit = 10 } = {}) => {
  return useQuery({
    queryKey: ['admin', 'transaction-notes', transactionId, { page, limit }],
    queryFn: async () => {
      if (!transactionId) {
        throw new Error('Transaction ID is required')
      }
      
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
      })
      
      const response = await adminAPI.get(`/transactions/${transactionId}/notes?${params.toString()}`)
      return response.data.data
    },
    enabled: !!transactionId,
    staleTime: 60000, // 1 minute
    refetchOnWindowFocus: false,
  })
}

export const useTransactionHistory = (transactionId) => {
  return useQuery({
    queryKey: ['admin', 'transaction-history', transactionId],
    queryFn: async () => {
      if (!transactionId) {
        throw new Error('Transaction ID is required')
      }
      
      const response = await adminAPI.get(`/transactions/${transactionId}/history`)
      return response.data.data
    },
    enabled: !!transactionId,
    staleTime: 60000, // 1 minute
    refetchOnWindowFocus: false,
  })
}